import { Checkbox, TextField } from '@mui/material';
import { makeStyles, withStyles } from '@mui/styles';
import { REQUIRED_FIXED_BOXES } from '../lib/constants';
const useStyles = makeStyles({
  input: {
    width: '70%',
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    border: '1px solid #585858',
    margin: 8,
    justifyContent: 'flex-start',
    flexGrow: 1,
  },
  rowContainer: {
    display: 'flex',
    border: '1px solid #585858',
    margin: 4,
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  inputVal: {
    height: 'auto',
    padding: '0 5px',
    fontSize: 14,
  },
});

const DarkerDisabledTextField = withStyles({
  root: {
    '& .MuiInputBase-root.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.7)',
    },
  },
})(TextField);

type BoxDataType = {
  boxId: number;
  boxNameText: string;
  boxValue: number | string | undefined;
  entryId: number | undefined;
  isReadOnly: boolean;
  isFixedBox: boolean;
  isYesNoBox: boolean;
  isAddedFromTerminal: boolean;
  isTimeBox: boolean;
  isAlphaNumeric: boolean;
};

interface ValueBoxProps {
  boxData: BoxDataType;
}

export function TerminalValueBox({ boxData }: ValueBoxProps) {
  const classes = useStyles();

  const getProperTimeString = (timeValStr: string): string => {
    if (timeValStr !== '') {
      return timeValStr.substring(0, 2) + ':' + timeValStr.substring(2);
    } else {
      return '';
    }
  };
  const getTimeStringFromNumber = (numberValue: number): string => {
    const numStr = numberValue.toString();

    if (numStr.length === 4) {
      return getProperTimeString(numStr);
    } else if (numStr.length === 3) {
      return getProperTimeString('0' + numStr);
    } else if (numStr.length === 2) {
      return '00:' + numStr;
    } else if (numStr.length === 1) {
      return '00:0' + numStr;
    } else {
      return '';
    }
  };

  const isTimeInput =
    !boxData.isAlphaNumeric &&
    ((boxData.isFixedBox && boxData.boxNameText !== 'Volume') ||
      boxData.isTimeBox);

  const hasSavedAlphaNumericValue =
    boxData.isAlphaNumeric && Boolean(boxData.entryId);
  const myValue = hasSavedAlphaNumericValue
    ? String(boxData.boxValue ?? '')
    : boxData.isAlphaNumeric
    ? ''
    : boxData.boxValue
    ? boxData.boxValue === 0 || boxData.boxValue === '0'
      ? ''
      : isTimeInput
      ? getTimeStringFromNumber(Number(boxData.boxValue))
      : String(boxData.boxValue)
    : '';

  const isRequiredEmpty =
    REQUIRED_FIXED_BOXES.includes(boxData.boxNameText) &&
    (myValue === '' || (!boxData.isAlphaNumeric && myValue === '0'));

  return (
    <div
      className={classes.rowContainer}
      style={isRequiredEmpty ? { border: '2px solid #d32f2f' } : undefined}
    >
      <div
        style={{
          padding: '2px 4px 2px 4px',
          backgroundColor: isRequiredEmpty ? '#ffcdd2' : '#d1d1d1',
          fontSize: 13,
        }}
      >
        {`${boxData.boxNameText}`}
      </div>

      <div
        style={{
          width: boxData.isYesNoBox ? 38 : 60,
          backgroundColor: '#ffffff',
          fontSize: 13,
          marginLeft: boxData.isYesNoBox ? 0 : 6,
        }}
      >
        {boxData.isYesNoBox ? (
          <Checkbox
            id={`yesNo-${boxData.boxId}`}
            name={`yesNo-${boxData.boxId}`}
            size="small"
            disabled={true}
            checked={myValue === 'Y'}
            style={{
              paddingRight: 2,
              paddingLeft: 2,
              paddingTop: 1,
              paddingBottom: 1,
            }}
          />
        ) : (
          <DarkerDisabledTextField
            id={`val-${boxData.boxId}`}
            name={`val-${boxData.boxId}`}
            disabled={true}
            InputProps={{
              classes: { input: classes.inputVal },
              disableUnderline: true,
              maxRows: 1,
            }}
            value={myValue}
            variant="standard"
          />
        )}
      </div>
    </div>
  );
}
